import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './processinitiativepage.cssmodule.scss';
import { Radio, FormGroup, Panel, Button, Accordion } from 'react-bootstrap';
import CreateIdeasHeader from '../Shared/CreateIdeasHeader';
import { convertInitiativeStateName, INITIATIVE_TYPE, INITIATIVE_STATE_PAID } from '../../constants';
import { Link } from 'react-router';
import Select from 'react-select';
import IdeaStateLabel from '../Shared/IdeaStateLabel';
import MultiUserSelect from '../Shared/MultiUserSelect';
import UserSelect from '../Shared/UserSelect';
import { injectIntl, intlShape, FormattedRelative } from 'react-intl';


import { REST_URL, INITIATIVE_STATE_NEW } from '../../constants';
import Adal from '../../adal/adal-request';
import RewardingForm from './RewardingForm';


var NotificationSystem = require('react-notification-system');


import classNames from 'classnames';
import { FormattedDate, FormattedTime } from 'react-intl';


class ProcessInitiativePage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      comment: '',
      decision: {
        InitiativeState: 0,
        Comment: ''
      },
      Experts: [],
      NewTargetUserId: -1,
      copiedInitiative: {},
      ExpertEmailSent: false
    }
  }



  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(nextProps) {
    const { currentInitiative } = nextProps;
    this.setState({
      copiedInitiative: currentInitiative
    });
  }

  updateComment(event) {
    var value = typeof event === 'object' ? event.target.value : event;
    this.setState({
      comment: value
    });
  }

  getFileUrl(file) {
    return REST_URL + "fileItems/download/" + file.Id + "?access_token=" + Adal.getCachedToken();
  }

  getRewardReportURL() {
    const { ideaId } = this.props;
    const { locale } = this.props;
    return REST_URL + "report/initiative/" + ideaId + "?access_token=" + Adal.getCachedToken() + '&lang=' + locale;

  }

  addComment() {
    const { actions } = this.props;
    const { ideaId } = this.props;

    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };

    actions.saveInitiativeCommentAction(ideaId, this.state.comment).then(() => {
      this.setState({
        comment: ''
      });

      this._notificationSystem.addNotification({
        title: '✔ ' + t("Success"),
        message: '',
        level: 'success',
        position: 'br'
      });

      actions.fetchInitiativeJournalsAction(ideaId);

    });
  }

  handleDecisionChange(propertyName, event) {
    var value = typeof event === 'object' ? event.target.value : event;
    const { decision } = this.state;
    let newDecision = { ...decision, [propertyName]: value };
    this.setState({
      decision: newDecision
    });
  }

  AddExpert(expert) {
    this.state.Experts.push(expert);
    this.setState({
      Experts: this.state.Experts
    });
  }

  RemoveExpert(expert) {
    var experts = this.state.Experts.filter((e) => {
      return e.Id != expert.Id;
    });
    this.setState({
      Experts: experts
    });
  }

  sendExpertRequests() {
    var reqs = [];
    const { ideaId } = this.props;
    const { actions } = this.props;
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };


    this.state.Experts.forEach((expert) => {
      reqs.push({
        InitiativeId: ideaId,
        TargetUserId: expert.Id,
        Comment: this.state.OpinionReqComment
      });
    });
    actions.sendInitiativeOpinionRequestsAction(ideaId, reqs).then(() => {
      this.setState({
        Experts: [],
        OpinionReqComment: '',
        ExpertEmailSent: true
      });
      this._notificationSystem.addNotification({
        title: t("Success"),
        message: t("ASK_EXPERT_OPINIONS"),
        level: 'success',
        position: 'br'
      });
      actions.fetchInitiativeJournalsAction(ideaId);
    });

  }

  submitNewDecision() {
    const { decision } = this.state;
    const { actions } = this.props;
    const { ideaId } = this.props;

    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };

    actions.saveInitiativeDecisionAction(ideaId, { ...decision, InitiativeId: ideaId }).then(() => {

      this.setState({
        decision: {
          InitiativeState: 0,
          Comment: ''
        }
      });

      actions.fetchInitiativeAction(ideaId).then(() => {
        actions.fetchInitiativeJournalsAction(ideaId);
      });

      this._notificationSystem.addNotification({
        title: t("Success"),
        message: t('SAVE_DECISION_OK'),
        level: 'success',
        position: 'br'
      });

    });
  }

  reAssignUser() {
    const { actions } = this.props;
    const { ideaId } = this.props;
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };


    actions.reAssignInitiativeAction(ideaId, this.state.NewTargetUserId).then(() => {
      this._notificationSystem.addNotification({
        title: t("Success"),
        message: t('REASSIGN_OK'),
        level: 'success',
        position: 'br'
      });
      this.setState({ NewTargetUserId: -1 });
      actions.fetchInitiativeJournalsAction(ideaId);
    });
  }

  printReport() {
    window.open(this.getRewardReportURL(), '_blank');
  }

  opinionReqCommentChanged(event) {
    var value = typeof event === 'object' ? event.target.value : event;
    this.setState({
      OpinionReqComment: value
    });

  }


  handleTypeChange(event) {
    const { copiedInitiative } = this.state;
    copiedInitiative.TypeId = event ? event.Id : -1;
    this.setState({
      copiedInitiative: copiedInitiative
    });
  }


  handleInputChange(propertyName, event) {
    var value = typeof event === 'object' ? event.target.value : event;
    if (propertyName === 'HideName') {
      value = event.target.checked ? true : false;
    }
    let initiative = Object.assign(this.state.copiedInitiative,
      { [propertyName]: value }
    );
    this.setState({
      copiedInitiative: initiative
    });
  }

  onFileUpload(event) {


    this.setState({
      Files: event.target.files,
      FileCount: event.target.files.length
    }
    );

  }


  handleUserSelect(event) {
    const selectedOriginator = event;
    const originatorId = event ? event.Id : -1;
    this.setState({
      originatorId: originatorId,
      selectedOriginator: selectedOriginator
    });
  }

  handleAddOriginator(event) {
    var copiedInitiative = this.state.copiedInitiative;
    var Authors = [...copiedInitiative.Authors];
    const selectedOriginator = this.state.selectedOriginator;
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };
    if (selectedOriginator) {
      var added = false;
      Authors.forEach((o) => {
        added = added || (selectedOriginator.Id == o.Id);
      });
      if (added) {
        this._notificationSystem.addNotification({
          title: t("Failed"),
          message: t('ADD_ORIGINATOR_FAILED'),
          level: 'error',
          position: 'br'
        });
      }
      else {
        Authors.push(selectedOriginator);
        copiedInitiative.Authors = Authors;
        this.setState({ originatorId: -1, copiedInitiative: copiedInitiative });
      }
    }
  }

  handleRemoveOriginator(user) {
    const id = user.Id;
    var copiedInitiative = this.state.copiedInitiative;

    var Authors = copiedInitiative.Authors;
    Authors = Authors.filter((o) => {
      return o.Id != id;
    });
    copiedInitiative.Authors = Authors;
    this.setState({ copiedInitiative: copiedInitiative });
  }



  saveCopiedData() {
    const { actions } = this.props;
    const { ideaId } = this.props;
    const { copiedInitiative } = this.state;
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };
    actions.putInitiativeAction(copiedInitiative, this.state.Files).then(() => {
      this.setState({
        Files: [],
        FileCount: [],
        originatorId: -1,
        selectedOriginator: null
      }
      );
      document.getElementById("file-field").value = "";

      actions.fetchInitiativeAction(ideaId).then(() => {
        actions.fetchInitiativeJournalsAction(ideaId);
      });
      this._notificationSystem.addNotification({
        title: t("Success"),
        message: t('SAVE_INITIATIVE_OK'),
        level: 'success',
        position: 'br'
      });
    },
      () => {
        this._notificationSystem.addNotification({
          title: t("Failed"),
          message: t('SAVE_INITIATIVE_FAILED'),
          level: 'error',
          position: 'br'
        });

      });

  }



  render() {
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };
    const { currentInitiative } = this.props;
    const { copiedInitiative } = this.state;
    const { initiativeTypes } = this.props;
    const { locale } = this.props;
    initiativeTypes.Types.forEach((itype) => {
      if (locale == 'en') {
        itype.label = itype.TitleEN ? itype.TitleEN : itype.Title;
      }
      else if (locale == 'sv') {
        itype.label = itype.TitleSV ? itype.TitleSV : itype.Title;
      }
      else {
        itype.label = itype.Title;
      }
    });

    if (currentInitiative && currentInitiative.Type) {
      let itype = currentInitiative.Type;
      if (locale == 'en') {
        itype.label = itype.TitleEN ? itype.TitleEN : itype.Title;
      }
      else if (locale == 'sv') {
        itype.label = itype.TitleSV ? itype.TitleSV : itype.Title;
      }
      else {
        itype.label = itype.Title;
      }
    }

    const { costCenters } = this.props;
    const { ideaId } = this.props;
    const { actions } = this.props;
    const emptyReward = {
      CostCenterId: 1,
      ConsultedWithOriginator: false,
      IsPaymentOrderPrinted: false,
      DecidedRewardAmount: 0,
      Comment: ''
    };

    const { authInfo } = this.props;
    const IsAdmin = authInfo.IsAdmin;
    const Authorized = authInfo.IsAdmin || (authInfo.LocalInfo && authInfo.LocalInfo.Id == currentInitiative.ManagerId);
    const inWorkFlow = authInfo.IsAdmin || (Authorized && currentInitiative.State < 4);
    const isExpert = inWorkFlow || (authInfo.LocalInfo && currentInitiative.ExpertIds && currentInitiative.ExpertIds.indexOf(authInfo.LocalInfo.Id) >= 0);
    return (
      <div className="container processinitiativepage-component" styleName="processinitiativepage-component">
        <NotificationSystem ref="notificationSystem" />
        <CreateIdeasHeader ideaType={this.props.ideaType} />

        <div className="brand-panel panel panel-default" styleName="form-container">
          <div className="panel-heading">
            {t('INITIATIVE') + ' #' + ideaId}
            {
              (!currentInitiative || currentInitiative.Id != ideaId) && (<span className="fa fa-refresh fa-spin" style={{ marginLeft: '10px' }}></span>)
            }
          </div>

          <div className="panel-body" style={{ visibility: (currentInitiative && currentInitiative.Id == ideaId) ? 'visible' : 'hidden' }}>
            <div className="row">
              {/*Left side */}
              <div className="col-md-7">
                <form className="form-horizontal form-condensed">
                  <div className="form-group">
                    <label className="col-sm-4 control-label">{t('Id')} :</label>
                    <div className="col-sm-8">
                      <p className="form-control-static">{currentInitiative.Id}</p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-sm-4 control-label word-break">{t('Title')} :</label>
                    <div className="col-sm-8">
                      {
                        IsAdmin ? (
                          <input className="form-control" placeholder={t('INITIATIVE_NAME')} value={copiedInitiative.Title} onChange={this.handleInputChange.bind(this, 'Title')} />
                        ) : (
                          <p className="form-control-static">{currentInitiative.Title}</p>
                        )
                      }
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-sm-4">{t('State')} :</label>
                    <div className="col-sm-8">
                      <p className="form-control-static"><IdeaStateLabel type={INITIATIVE_TYPE} state={currentInitiative.State} /></p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-sm-4">{t('Type')} :</label>
                    <div className="col-sm-8">
                      {
                        IsAdmin ? (<Select
                          name="form-field-name"
                          value={copiedInitiative.TypeId}
                          options={initiativeTypes.Types}
                          onChange={this.handleTypeChange.bind(this)}
                          placeholder={t('Select') + '...'}
                        />) : (<p className="form-control-static">{currentInitiative.Type ? currentInitiative.Type.label : ''}</p>)
                      }
                    </div>
                  </div>


                  {
                    IsAdmin && <div className="form-group">
                      <label className="control-label col-sm-4">{t('Created by')}</label>
                      <div className="row col-sm-8">
                        <div className="col-md-10">
                          <UserSelect includeManager="true" userId={this.state.originatorId} onSelectUser={this.handleUserSelect.bind(this)} />
                        </div>
                        <div className="col-md-2" style={{ paddingLeft: '0px' }}>
                          <button type="button" className="btn btn-default btn-brand pull-left" onClick={this.handleAddOriginator.bind(this)}>{t('Add')}</button>
                        </div>
                      </div>
                    </div>
                  }
                  {IsAdmin && <div className="form-group">
                    <div className="row col-sm-8 col-md-offset-4">
                      <table className="table table-condensed table-bordered ">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{t('Display Name')}</th>
                            <th>{t('Remove')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            (copiedInitiative && copiedInitiative.Authors ? copiedInitiative.Authors : []).map((m, idx) =>
                            (<tr key={m.Id}>
                              <td><Link to={"/user/" + m.Id}>{m.Id}</Link></td>
                              <td>{m.DisplayName}</td>
                              <td><button type="button" className="btn btn-default btn-danger btn-xs" onClick={this.handleRemoveOriginator.bind(this, m)}><i className="glyphicon glyphicon-remove" /></button></td>
                            </tr>)
                            )
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  }

                  {!IsAdmin &&
                    <div className="form-group">
                      <label className="control-label col-sm-4">{t('Created by')} :</label>
                      <div className="col-sm-8">
                        {
                          currentInitiative.HideName ?
                            <p className="form-control-static">-</p>
                            :
                            <table className="table table-condensed table-bordered ">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>{t('Display Name')}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  (currentInitiative.Authors ? currentInitiative.Authors : []).map((m, idx) =>
                                  (<tr key={m.Id}>
                                    <td>{m.Id}</td>
                                    <td >{m.DisplayName}</td>
                                  </tr>)
                                  )
                                }
                              </tbody>
                            </table>
                        }
                      </div>
                    </div>
                  }

                  <div className="form-group">
                    <label className="control-label col-sm-4">{t('Responsible person')} :</label>
                    <div className="col-sm-8">
                      <p className="form-control-static">{currentInitiative.Manager ? currentInitiative.Manager.DisplayName : ''}</p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-sm-4">{t('Created date')} :</label>
                    <div className="col-sm-8">
                      <p className="form-control-static">
                        <FormattedDate className="form-control-static" value={currentInitiative.Created ? currentInitiative.Created : new Date()} />
                        &nbsp;
                        <FormattedTime className="form-control-static" value={currentInitiative.Created ? currentInitiative.Created : new Date()} />
                      </p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="control-label col-sm-4">{t('CURRENT_SITUATION')} :</label>
                    <div className="col-sm-8">

                      {
                        IsAdmin ? (
                          <textarea rows="4" className="form-control" value={copiedInitiative.CurrentSituation || ''} onChange={this.handleInputChange.bind(this, 'CurrentSituation')} />
                        ) : (<p className="form-control-static word-break" >{currentInitiative.CurrentSituation}</p>)
                      }

                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label col-sm-4">{t('IMPROVEMENT_PROPOSAL')} :</label>
                    <div className="col-sm-8">

                      {
                        IsAdmin ? (
                          <textarea rows="4" className="form-control" value={copiedInitiative.Improvement || ''} onChange={this.handleInputChange.bind(this, 'Improvement')} />
                        ) : (<p className="form-control-static word-break">{currentInitiative.Improvement}</p>)
                      }
                    </div>
                  </div>



                  <div className="form-group">
                    <label className="control-label col-sm-4">{t('Attached files')} :</label>
                    <div className="col-sm-8">
                      <div className="form-control-static">
                        <ul className="list-unstyled">
                          {
                            currentInitiative.Files.map((file, idx) => (<li key={file.Id}> <a href={this.getFileUrl(file)}>{file.FileName}</a> </li>))
                          }
                        </ul>
                        {
                          IsAdmin && (
                            <input type="file" id="file-field" onChange={this.onFileUpload.bind(this)} multiple />
                          )
                        }

                      </div>
                    </div>
                  </div>


                  {

                    false && Authorized && currentInitiative.State == INITIATIVE_STATE_PAID &&
                    <div className="form-group">
                      <label className="control-label col-sm-4">{t('Rewarding template')} :</label>
                      <div className="col-sm-8">
                        <button type="button" className="btn btn-default btn-brand btn-sm" onClick={this.printReport.bind(this)}>
                          {t('Print')}
                        </button>
                      </div>
                    </div>
                  }
                  {
                    IsAdmin && (
                      <div className="form-group">
                        <div className="col-sm-8 col-md-offset-4">
                          <button type="button" disabled={
                            !(copiedInitiative &&
                              copiedInitiative.Authors &&
                              copiedInitiative.Authors.length > 0 &&
                              copiedInitiative.TypeId &&
                              copiedInitiative.Title &&
                              copiedInitiative.CurrentSituation &&
                              copiedInitiative.Improvement)
                          } className="btn btn-default btn-brand pull-right"
                            onClick={this.saveCopiedData.bind(this)}>
                            {t('Save')}
                          </button>
                        </div>
                      </div>
                    )
                  }


                </form>
                <br />
                {
                  isExpert &&
                  <Panel style={{ marginBottom: '5px' }} collapsible defaultExpanded header={t('Add comment or opinion')} className="brand-panel">
                    <form className="form-horizontal form-condensed">
                      <div className="form-group">
                        <label className="control-label col-sm-4">{t('Comment')} :</label>
                        <div className="col-sm-8">
                          <textarea rows="4" value={this.state.comment} onChange={this.updateComment.bind(this)} className="form-control" style={{ marginBottom: '10px' }} />
                          <button disabled={!(this.state.comment)} onClick={this.addComment.bind(this)} type="button" className="btn btn-default btn-brand pull-right">
                            {t('Add')}
                          </button>
                        </div>
                      </div>
                    </form>
                  </Panel>
                }
                <Accordion>


                  {
                    inWorkFlow &&
                    <Panel header={t('Make decision')} eventKey="1" className="brand-panel">
                      <form className="form-horizontal form-condensed">
                        <div className="form-group">
                          <label className="col-sm-4 control-label">* {t('Comment')} : </label>
                          <div className="col-sm-8">
                            <textarea rows="4" onChange={this.handleDecisionChange.bind(this, 'Comment')} className="form-control" value={this.state.decision.Comment} />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="col-sm-4 control-label">* {t('Status')} : </label>
                          <div className="col-sm-8">
                            {IsAdmin &&
                              <Radio value={INITIATIVE_STATE_NEW} name="stateOptions" onChange={this.handleDecisionChange.bind(this, 'InitiativeState')} checked={this.state.decision.InitiativeState == INITIATIVE_STATE_NEW}>
                                {t(convertInitiativeStateName(INITIATIVE_STATE_NEW))}
                              </Radio>
                            }
                            <Radio value="2" name="stateOptions" onChange={this.handleDecisionChange.bind(this, 'InitiativeState')} checked={this.state.decision.InitiativeState == 2}>
                              {t(convertInitiativeStateName(2))}
                            </Radio>
                            <Radio value="3" name="stateOptions" onChange={this.handleDecisionChange.bind(this, 'InitiativeState')} checked={this.state.decision.InitiativeState == 3}>
                              {t(convertInitiativeStateName(3))}
                            </Radio>
                            <Radio value="5" name="stateOptions" onChange={this.handleDecisionChange.bind(this, 'InitiativeState')} checked={this.state.decision.InitiativeState == 5}>
                              {t(convertInitiativeStateName(5))}
                            </Radio>
                            {IsAdmin &&
                              <Radio value="6" name="stateOptions" onChange={this.handleDecisionChange.bind(this, 'InitiativeState')} checked={this.state.decision.InitiativeState == 6}>
                                {t(convertInitiativeStateName(6))}
                              </Radio>
                            }


                          </div>
                        </div>
                        <button onClick={this.submitNewDecision.bind(this)} disabled={!(this.state.decision.InitiativeState && this.state.decision.Comment)} type="button" className="btn btn-default btn-brand pull-right">{t('Save and send')}</button>

                      </form>
                    </Panel>
                  }
                  {
                    inWorkFlow &&
                    <Panel header={t('Ask expert opinion')} eventKey="2" className="brand-panel">
                      <form>
                        <MultiUserSelect value={this.state.Experts} className="form-group" onRemove={this.RemoveExpert.bind(this)} onAdd={this.AddExpert.bind(this)}>
                          {
                            this.state.ExpertEmailSent && (
                              <div className="alert alert-success" style={{ marginBottom: '0px' }}>
                                <strong>{t('Email sent')}! </strong>{t('To continue, please select a name and click')} <strong>{t('Add')}</strong>.
                              </div>
                            )
                          }
                        </MultiUserSelect>
                        <label>* {t('Comment')}</label>
                        <textarea rows="4" maxLength="1000" value={this.state.OpinionReqComment || ''} onChange={this.opinionReqCommentChanged.bind(this)} className="form-control" style={{ marginBottom: '10px' }} />
                        <button type="button" disabled={!(this.state.Experts && this.state.Experts.length > 0) || !this.state.OpinionReqComment} className="btn btn-default btn-brand pull-right" onClick={this.sendExpertRequests.bind(this)}>
                          {t('Send emails')}
                        </button>
                      </form>
                    </Panel>
                  }
                  {
                    IsAdmin &&
                    <Panel header={t('Reassign to different person')} eventKey="3" className="brand-panel">
                      <UserSelect userId={this.state.NewTargetUserId} onSelectUser={(user) => { this.setState({ NewTargetUserId: user ? user.Id : null }); }} />
                      <Button disabled={!this.state.NewTargetUserId} className="btn-brand pull-right" style={{ marginTop: '5px' }} onClick={this.reAssignUser.bind(this)}>
                        {t('Reassign')}</Button>
                    </Panel>
                  }
                </Accordion>


              </div>

              {/*Right side */}
              <div className="col-md-5">
                <strong>{t('Journals')}</strong>
                <table className="table table-condensed table-bordered fixed-table">
                  <thead>
                    <tr>
                      <th className="column-fixed-c">{t('Description')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      currentInitiative.Journals.map((j) => (
                        <tr key={j.Id}>

                          <td className="column-fixed-c">
                            <strong><FormattedDate value={j.Created} />&nbsp;<FormattedTime value={j.Created} /> - {j.CreatedByDisplayName}</strong>
                            <br />
                            <IdeaStateLabel type={INITIATIVE_TYPE} state={j.InitiativeState} />
                            <br />
                            {
                              j.OpinionRequest && (
                                <div><span className='label label-primary'>{t('Expert Opinion')}</span></div>
                              )
                            }
                            <p>
                              {j.Data ? t(j.Comment) : j.Comment} {j.Data}
                            </p>
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
            {
              inWorkFlow && (<div className="row">
                <div className="col-md-12">
                  <Accordion>
                    <Panel header={t('Rewarding form')} eventKey="1" className="brand-panel">
                      <RewardingForm inWorkFlow={inWorkFlow} rewardReportURL={this.getRewardReportURL()} actions={actions} costCenters={costCenters} ideaId={ideaId} reward={currentInitiative.InitiativeReward ? currentInitiative.InitiativeReward : emptyReward} />
                    </Panel>
                  </Accordion>
                </div>
              </div>)
            }

          </div>


        </div>
      </div>
    );
  }
}

ProcessInitiativePage.displayName = 'ProcessInitiativePage';
ProcessInitiativePage.propTypes = {};
ProcessInitiativePage.defaultProps = {};

export default injectIntl(cssmodules(ProcessInitiativePage, styles));


// WEBPACK FOOTER //
// ./components/ProcessIdeas/ProcessInitiativePage.js